<template>
  <div>
    <slot name="prepend" :detalhes_produto="detalhesProduto" />

    <table style="width: 100%;border-collapse: collapse;">
      <template v-for="(linha, index) in linhas">
        <linha
          :linha="linha"
          :dados="detalhesProdutoFormatado"
          :key="index"
          :maximoDeColunas="maximoDeColunas"
        >
          <template #coluna.titulo.peso_compras="{texto}">
            <Legenda :titulo="texto" legenda="Representa a importância decorrente da combinação de todas as curvas apresentadas. Sendo inversamente proporcional, ou seja, quanto menor o valor maior a importância do item e consequentemente, maior a prioridade de análise">
              {{ texto }}
            </Legenda>
          </template>

          <template #coluna.valor.preco_compra="{valor}">
            <FormatarMoeda :tipo="detalhesProduto.moeda" />
            {{ Helpers.formatarValor(converterEmbalagemValor(valor, true)) }}
          </template>

          <template #coluna.valor.total_compra="{ valor }">
            <FormatarMoeda :tipo="detalhesProduto.moeda" />
            {{ valor }}
          </template>

          <template #coluna.valor.tempo_medio_ressuprimento="{valor}">
            {{ Helpers.formatarValorComCasas(valor, 1) }} dias
          </template>

          <template #coluna.titulo.tempo_medio_ressuprimento="{coluna}">
            <div class="d-flex align-center">
              <Legenda :titulo="coluna.texto" legenda="Ressuprimento ou tempo de reabastecimento ou Lead time, é o prazo completo para a reposição da SKU, contado desde a identificação da respectiva necessidade, passando pelo processo de reposição (planejamento e aquisição), fabricação e despacho pelo fornecedor, até o recebimento e liberação para consumo">
                <span v-text="coluna.texto" class="font-weight-medium" />
              </Legenda>

              <Ressuprimento
                v-if="habilitar_edicao_parametros"
                class="mt-n1px"
                :produto="{...produto, ...detalhesProduto, ressuprimento_manual_ativo: detalhesProduto.ressuprimento_manual === 'S', qtde_dias_tempo_ressuprimento: detalhesProduto.tempo_medio_ressuprimento}"
                @update:tempo-ressuprimento="$emit('update:tempo-ressuprimento', {})"
              />
            </div>
          </template>

          <template #coluna.titulo.lote_minimo="{coluna}">
            <div class="d-flex align-center">
              <Legenda :titulo="coluna.texto" legenda="Trata-se de uma quantidade mínima que o fornecedor está disposto a efetuar a venda, abaixo dessa quantidade não é interessante produzir/vender">
                <span v-text="coluna.texto" class="font-weight-medium" />
              </Legenda>

              <LoteMinimo
                v-if="habilitar_edicao_parametros"
                class="mt-n1px"
                :produto="{...produto, ...detalhesProduto, filial: produto.id_filial, idproduto: produto.id_produto}"
                @alterou-lote-minimo="$emit('update:lote-minimo', {})"
              >
                <template #ativador>
                  <v-icon size="14" class="cursor-pointer">mdi-pencil</v-icon>
                </template>
              </LoteMinimo>
            </div>
          </template>

          <template #coluna.titulo.tempo_forecast="{coluna}">
            <div class="d-flex align-center">
              <Legenda :titulo="coluna.texto" legenda="Refere-se ao horizonte futuro da analise feita pelo SYSTOCK, engatilhando um item que no momento não esteja na hora de comprar, antecipando esse movimento para se ter mais vantagens. Ou seja, O item pode não estar em momento de compras agora, porém em um futuro próximo sim. Dessa forma ajudará o time a agrupar as compras de forma mais assertiva, unificando fretes, volume de compras, poder de barganha e etc. próximo entrará ou não em momento de compras.">
                <span v-text="coluna.texto" class="font-weight-medium" />
              </Legenda>

              <PrevisaoGatilho
                v-if="habilitar_edicao_parametros && !produto.produto_eh_combinacao"
                :produto="{...produto, tempo_forecast: detalhesProduto.tempo_forecast}"
                @update:previsao-gatilho="$emit('update:previsao-gatilho', $event)"
              />
            </div>
          </template>

          <template #coluna.valor.lote_minimo="{coluna}">
            {{ Helpers.formatarValor(converterEmbalagemValor(detalhesProduto.lote_minimo) || 0) }}
            {{ embalagemMasterAtivo ? detalhesProduto.unidade_master : detalhesProduto.unidade_compra }}
          </template>

          <template #coluna.titulo.qtde_similares="{texto}">
            <div class="d-flex align-center">
              <Legenda :titulo="texto">
                <span v-text="texto" class="font-weight-medium" />

                <template #legenda>
                  São itens análogos, que possuem a mesma natureza, semelhança, podendo ou não ter a mesma equivalência. Podendo ser classificados como:<br />
                  <span class="font-weight-medium">INTERCAMBIÁVEIS</span>: Itens Equivalentes em qualidade e preço. Na ausência de um o cliente leva o outro;<br />
                  <span class="font-weight-medium">NÃO-INTERCAMBIÁVIS</span>: Semelhantes mas não equivalentes. Na ausência de um o cliente NÃO leva o outro;<br />
                </template>
              </Legenda>

              <Similar
                v-if="!produto.produto_eh_categoria"
                :habilitar_edicao_parametros="habilitar_edicao_parametros" :produto="{...produto, descricao_produto: detalhesProduto.descricao_produto, multiplo_compra: detalhesProduto.multiplo_compra, tipo_fator_conversao: detalhesProduto.tipo_fator_conversao, idunidade_medida: detalhesProduto.unidade_compra}"
                @update:similar="ev => $emit('update:similar', ev)"
              />
            </div>
          </template>

          <template #coluna.valor.qtde_similares="{valor}">
            <span>{{ Helpers.formatarValor(valor) }} similar{{ (valor > 1) ? 'es' : '' }}</span>
          </template>

          <template #coluna.valor.nome_produto_heranca="{valor}">
            <v-tooltip bottom open-delay="700">
              <template #activator="{ on, attrs }">
                <p v-bind="attrs" v-on="on" class="ma-0 text-truncate cursor-help" style="width: 180px">
                  {{valor}}
                </p>
              </template>
              <span>{{valor}}</span>
            </v-tooltip>
          </template>

          <template #coluna.valor_ultima_compra="{ coluna }">
            <template v-if="detalhesProduto.campos_personalizados && detalhesProduto.campos_personalizados.valor_ultima_compra && Number(detalhesProduto.campos_personalizados.valor_ultima_compra.valor || 0) > 0">
              <span v-text="coluna.texto" class="font-weight-medium" />

              <LegendaTotalGeralEPorFilial
                v-if="detalhesProduto.campos_personalizados"
                titulo="Valor da Última Compra"
                :campo_personalizado="detalhesProduto.campos_personalizados.valor_ultima_compra"
              />
            </template>

            <template v-else>&nbsp;</template>
          </template>

          <template #coluna.valor_ultima_entrada_sem_st="{ coluna }">
            <template v-if="detalhesProduto.campos_personalizados && detalhesProduto.campos_personalizados.valor_ultima_entrada_sem_st && Number(detalhesProduto.campos_personalizados.valor_ultima_entrada_sem_st.valor || 0) > 0">
              <span v-text="coluna.texto" class="font-weight-medium" />

              <LegendaTotalGeralEPorFilial
                titulo="Valor da Última Entrada sem ST"
                :campo_personalizado="detalhesProduto.campos_personalizados.valor_ultima_entrada_sem_st"
              />
            </template>

            <template v-else>&nbsp;</template>
          </template>

          <template #coluna.titulo.estoque_seguranca="{texto}">
            <Legenda :titulo="texto" legenda="O estoque de segurança, ou estoque mínimo, é uma ferramenta logística utilizada para mitigar riscos de stockout , ou quebra de estoque. Sendo possível se precaver de incertezas relacionadas à flutuações em oferta e demanda">
              <span v-text="texto" />
            </Legenda>
          </template>

          <template #coluna.valor.estoque_seguranca="{valor}">
            {{Helpers.formatarValor(converterEmbalagemValor(valor))}}
          </template>

          <template #coluna.titulo.ponto_pedido="{texto}">
            <Legenda :titulo="texto" legenda="O ponto de pedido ou reorder point (ROP) refere-se ao momento certo para fazer uma compra de reposição do estoque, dando tempo para que uma determinada SKU possa ser ressuprida pelo fornecedor, sem que haja exposição seu estoque a ruptura">
              <span v-text="texto" />
            </Legenda>
          </template>

          <template #coluna.valor.ponto_pedido="{valor}">
            {{Helpers.formatarValor(converterEmbalagemValor(valor))}}
          </template>

          <template #coluna.titulo.estoque_maximo="{texto}">
            <Legenda :titulo="texto" legenda="Estabelece a maior quantidade necessária em estoque para determinada SKU">
              <span v-text="texto" />
            </Legenda>
          </template>

          <template #coluna.valor.estoque_maximo="{valor}">
            {{Helpers.formatarValor(converterEmbalagemValor(valor))}}
          </template>

          <template #coluna.titulo.estoque_minimo="{texto}">
            <Legenda :titulo="texto">
              <span v-text="texto" />

              <template #legenda>
                Viés de exposição de loja. Compra-se uma quantidade necessária para melhorar a exposição dos produtos, desconsiderando a demanda de vendas.<br />
                <span class="font-weight-medium">Prós</span>: otimização na exposição da loja, gôndolas sempre cheias atraem clientes, estética potencializa a venda;<br />
                <span class="font-weight-medium">Contra</span>: excesso de produtos, muito capital imobilizado, capital inicial elevado para formação de novas filiais, análise subjetiva dependendo da experiência e bom senso do time;<br />
              </template>
            </Legenda>
          </template>

          <template #coluna.valor.estoque_minimo="{valor}">
            {{Helpers.formatarValor(converterEmbalagemValor(valor))}}
          </template>

          <template #coluna.valor.estoque="{valor}">
            <span v-if="detalhesProduto.produto_em_analise_por_lote" class="text-gray-300">
              {{Helpers.formatarValor(converterEmbalagemValor(detalhesProduto.estoque_origem))}} /
            </span>

            {{Helpers.formatarValor(converterEmbalagemValor(valor))}}
          </template>

          <template #coluna.valor.estoque_bloqueado="{valor}">
            {{Helpers.formatarValor(converterEmbalagemValor(valor))}}
          </template>

          <template #coluna.estoque_transito="{coluna}">
            <p class="ma-0 font-weight-medium">
              Itens Pendentes
              <v-icon small color="#D60E2B">mdi-truck</v-icon>
            </p>
            <p class="ma-0">
              <span title="Quantidade Pendente" style="color: #D60E2B; cursor: help;">
                {{Helpers.formatarValor(converterEmbalagemValor(detalhesProduto[coluna.valor]))}}
              </span>
              /
              <span title="Quantidade Faturada" style="color: #044716; cursor: help;">
                {{ Helpers.formatarValor(converterEmbalagemValor(detalhesProdutoFormatado.estoque_faturado)) }}
              </span>
            </p>
          </template>

          <template #coluna.valor.estoque_avaria="{valor}">
            {{Helpers.formatarValor(converterEmbalagemValor(valor))}}
          </template>

          <template #coluna.valor.estoque_reservado="{valor}">
            {{Helpers.formatarValor(converterEmbalagemValor(valor))}}
          </template>

          <template #coluna.valor.qtde_compra="{valor}">
            {{Helpers.formatarValor(converterEmbalagemValor(valor))}}
          </template>

          <template #coluna.valor.mediaTrimestre="{valor}">
            {{Helpers.formatarValor(converterEmbalagemValor(valor))}}
          </template>

          <template #coluna.valor.mediaSemestre="{valor}">
            {{Helpers.formatarValor(converterEmbalagemValor(valor))}}
          </template>

          <template #coluna.valor.mediaAno="{valor}">
            {{Helpers.formatarValor(converterEmbalagemValor(valor))}}
          </template>

          <template #coluna.titulo.consumo_medio_mensal="{texto}">
            <div class="d-flex align-center">
              <Legenda :titulo="texto" legenda="Valor calculado do quanto se espera vender no próximo mês, baseado no seu comportamento histórico">
                <span v-text="texto" />
              </Legenda>

              <ProjecaoVendasParametrizavel
                :produto="produto"
                :abrir_modal="dialog_tipo_projecao_venda"
                :tipo_fator_conversao="detalhesProduto.tipo_fator_conversao"
                :multiplo_compra="Number(detalhesProduto.multiplo_compra)"
                @update:tipo-projecao-aplicado="ev => $emit('update:tipo-projecao-aplicado', ev)"
              />
            </div>
          </template>

          <template #coluna.valor.consumo_medio_mensal="{valor}">
            <div class="d-flex">
              {{ Helpers.formatarValor(converterEmbalagemValor(valor)) }}

              <div
                class="d-flex align-center ml-2 mb-2 px-1 bra-5"
                :style="formatarBadgeTipoProjecao"
                :class="truncarTipoProjecaoVendas
                  ? 'w-70-porcento' : ''"
              >
                <v-icon
                  v-if="detalhesProdutoFormatado.tipo_projecao_vendas !== 'padrao_systock'"
                  class="mr-1"
                  size="15"
                  :color="formatarBadgeTipoProjecao.color"
                >
                  $ProjectorScreenChart
                </v-icon>

                <span
                  :class="truncarTipoProjecaoVendas
                  ? 'tailwind-truncate w-80-porcento' : ''"
                >
                  {{ formatarTipoProjecaoVendas(detalhesProdutoFormatado.tipo_projecao_vendas) }}
                  {{ truncarTipoProjecaoVendas ? '...' : ''}}
                </span>
              </div>
            </div>
          </template>

          <template #coluna.titulo.estoque="{texto}">
            <div class="d-flex align-center">
              <Legenda :titulo="texto" legenda="Estoque ou saldo é a acumulação armazenada de uma determinada SKU em um ou mais locais de armazenamento">
                <span v-text="texto" />
              </Legenda>

              <DetalhamentoEstoque
                :produto="{...detalhesProduto, ...produto, filial: produto.id_filial === 9999 ? 0 : produto.id_filial, idproduto: produto.id_produto}"
                ocultar_ativador_padrao
              >
                <template #ativador>
                  <v-icon class="cursor-pointer" :size="15" title="Detalhamento do estoque por filial">mdi-information-outline</v-icon>
                </template>
              </DetalhamentoEstoque>

              <AnalisePorLote
                v-if="flagAnalisePorLote && !produto.produto_eh_combinacao"
                :produto="produto"
                @update:analise-por-lote="$emit('update:parametrizacao')"
              />
            </div>
          </template>

          <template #coluna.titulo.cobertura_estoque="{texto}">
            <Legenda :titulo="texto" :legenda="`${texto} ou Cobertura Instantânea é o índice utilizado para medir o tempo que o estoque, em determinado período, consegue cobrir as demandas futuras,  ou seja, o tempo que o produto levará para sair do estoque`">
              <span v-text="texto" />
            </Legenda>
          </template>

          <template #coluna.titulo.giro_diario="{texto}">
            <Legenda :titulo="texto" legenda="Indicador que aponta a circulação dos itens, ou seja, quantas vezes tudo o que foi comprado foi vendido/consumido">
              <span v-text="texto" />
            </Legenda>
          </template>

          <template #coluna.titulo.status_produto="{texto}">
            <Legenda :titulo="texto">
              <span v-text="texto" />

              <template #legenda>
                Indicador que mede o nível do estoque, sendo classificado em 5 (cinco) níveis:<br />
                <span class="font-weight-medium">1. Excesso:</span> Saldo de estoques acima do estoque máximo;<br />
                <span class="font-weight-medium">2. Adequado:</span> Saldo de estoques dentro da normalidade, ou seja, menor que o estoque máximo, maior que o ponto de pedido;<br />
                <span class="font-weight-medium">3. Baixa Exposição a Ruptura:</span> Saldo de estoques menor ou igual ao ponto de pedido, porém a cobertura de estoques é maior que o leadtime do fornecedor;<br />
                <span class="font-weight-medium">4. Elevada Exposição a Ruptura:</span> Saldo de estoques menor ou igual ao ponto de pedido, porém a cobertura de estoques é menor que o leadtime do fornecedor;<br />
                <span class="font-weight-medium">5. Ruptura:</span> Saldo de estoques igual a zero;<br />

              </template>
            </Legenda>
          </template>

          <template #coluna.valor.status_produto="{valor}">
            <div v-text="valor" :title="valor" class="text-truncate cursor-help w-90" />
          </template>

          <template #coluna.titulo.nivel_estoque="{texto}">
            <Legenda :titulo="texto" legenda="Informa em percentual a quantidade de estoque de uma determinada SKU, frente aos seus parâmetros de estoque máximo e segurança">
              <span v-text="texto" />
            </Legenda>
          </template>

          <template #coluna.valor.nivel_estoque="{valor}">
            <nivel-estoque-progress-circular :valor="valor" :status-produto="detalhesProduto.status_produto" />
          </template>

          <template #coluna.titulo.cobertura_manual_produto="{coluna}">
            <div class="d-flex align-center">
              <Legenda :titulo="coluna.texto" legenda="Definição manual do alcance máximo do estoque, disposto em dias. Ou, definição manual do tempo que os itens levarão para sair do estoque">
                <span v-text="coluna.texto" class="font-weight-medium" />
              </Legenda>

              <CoberturaEstoqueManual
                v-if="habilitar_edicao_parametros"
                :produto="produto"
                class="mt-n1px"
                @update:cobertura-manual-estoque="$emit('update:cobertura-manual-estoque', $event)"
              />
            </div>
          </template>

          <template #coluna.valor.cobertura_manual_produto="{valor}">
            <template v-if="valor > 0">{{ `${Helpers.formatarValor(valor)} dias` }}</template>
            <template v-else>-</template>
          </template>

          <template #coluna.valor.raio_x="{valor}">
            <p class="mb-n2 font-weight-medium">
              {{ valor }}
            </p>
            <RaioX :produto="detalhesProdutoFormatado"/>
          </template>

          <template #coluna.valor.tipo_heranca="{valor}">
            <Legenda v-if="valor === 1" titulo="Lançamento" legenda="Herda o comportamento de saídas no período de lançamento do produto">
              Lançamento
            </Legenda>
            <Legenda v-else-if="valor === 2" titulo="Contínua" legenda="Herda o comportamento de saídas no período atual">
              Contínua
            </Legenda>
            <span v-else>-</span>
          </template>

          <template #heranca.append>
            <div class="d-flex flex-row align-center ma-0 pa-0">
              <Heranca
                v-if="habilitar_edicao_parametros"
                :produto="{
                  ...produto,
                  id_produto_heranca: detalhesProduto.heranca ? detalhesProduto.heranca.idproduto : null,
                  tipo_heranca: detalhesProduto.heranca ? detalhesProduto.heranca.tipo_heranca : null
                }"
                @update:heranca="ev => $emit('update:heranca', ev)"
              />
              <span v-if="detalhesProduto.verificaHeranca > 0" v-text="'Fora de linha por herança'" class="text-red pt-1px ml-1 text-uppercase" />
            </div>
          </template>

          <template #ultima-compra.append>
            <div class="d-flex align-center">
              <UltimasCompras
                :produto="{...detalhesProduto, ...produto}"
                @update:desconsiderar-pedido-em-transito="ev => $emit('update:desconsiderar-pedido-em-transito', ev)"
              />

              <ComparativoPreco
                v-if="!produto.produto_eh_combinacao"
                :produto="produto"
                class="mt-n1px"
              />

              <DashComparandoEvolucaoDePrecoDeCompras
                :produto="{...detalhesProduto, ...produto}"
              />
            </div>
          </template>

          <template #media-venda-ultimos-meses.append>
            <UltimasVendasProduto
              :click_bar="click_bar"
              :produto="{...detalhesProduto, ...produto, filial: produto.id_filial === 9999 ? 0 : produto.id_filial, idproduto: produto.id_produto}"
              @consumos-desconsiderados="ev => $emit('consumos-desconsiderados', ev)"
            />
          </template>

          <template #coluna.titulo.percentual_projecao="{coluna}">
            <div class="d-flex align-center">
              <Legenda :titulo="coluna.texto" legenda="Refere-se a possibilidade do comprador influenciar tanto para mais quanto para menos a projeção de vendas calculada">
                <span v-text="coluna.texto" class="font-weight-medium" />
              </Legenda>

              <InfluenciaDeProjecao
                v-if="habilitar_edicao_parametros"
                :produto="produto"
                class="mt-n1px"
                @update:influencia-projecao="ev => $emit('update:influencia-projecao', ev)"
              />
            </div>
          </template>

          <template #coluna.valor.percentual_projecao="{valor}">
            <span v-text="`${valor || 0}%`" :class="{'text-red': detalhesProduto.fator_atuacao < 1, 'text-green': detalhesProduto.fator_atuacao > 1}" />
          </template>

          <template #coluna.valor.promo="{valor}">
            <DialogModeloPrevisaoAtual
              v-model="dialog_modelo_previsao_atual"
              v-if="detalhesProduto.tipo_projecao_vendas !== 'padrao_systock' && 1 === 2"
              :tipo_projecao_vendas="tipoProjecaoVendas"
              @confirmar="() => dialog_tipo_projecao_venda = !dialog_tipo_projecao_venda"
              @fechar="() => dialog_modelo_previsao_atual = false"
            >
              <template #activator="{ on, attrs }">
                <div
                  v-bind="attrs" v-on="on"
                  style="background-color: #EEE8FD; color: #5316D6"
                  class="ma-1 pa-1 d-inline-flex align-center bra-7 cursor-pointer"
                  @click="() => dialog_modelo_previsao_atual = true"
                >
                  <v-icon class="mr-1" size="17" color="#5316D6">$MegaphoneSimple</v-icon>
                  <span class="font-13">Promo</span>
                  <v-icon class="ml-1" size="17" color="#5316D6">$Info</v-icon>
                </div>
              </template>
            </DialogModeloPrevisaoAtual>

            <span v-else />
          </template>
        </linha>
      </template>
    </table>
  </div>
</template>

<script>
import RaioX from "../../compra/raio-x-produto/RaioXProduto.vue";
import Linha from "./LinhaTabelaDetalhesProdutos";
import ProdutoAPI from "../../../api/produto.js";
import NivelEstoqueProgressCircular from "./NivelEstoqueProgressCircular";
import UltimasCompras from "./UltimasCompras/Index.vue";
import LoteMinimo from "@/components/compra/detalhesProduto/LoteMinimo"
import Ressuprimento from "@/components/produto/detalhes/Acoes/Ressuprimento"
import UltimasVendasProduto from "@/components/produto/detalhes/UltimasVendas/Index";
import DetalhamentoEstoque from "@/components/compra/detalhesProduto/DetalhamentoEstoque";
import InfluenciaDeProjecao from "@/components/produto/detalhes/ProjecaoVenda/InfluenciaDeProjecao.vue";
import CoberturaEstoqueManual from "@/components/produto/detalhes/Acoes/CoberturaEstoqueManual";
import {converterEmbalagemValor, converterEmbalagemValorDinheiro} from "@/components/compra/ProdutosGerais/ConversorEmbalagem";
import PrevisaoGatilho from "@/components/produto/detalhes/Acoes/PrevisaoGatilho";
import Similar from "@/components/produto/detalhes/Acoes/Similar/Index";
import Heranca from "@/components/produto/detalhes/Acoes/Heranca/Index";
import Legenda from "@/components/produto/detalhes/Legenda";
import ComparativoPreco from "@/components/compra/detalhesProduto/ComparativoPreco/Index.vue";
import ProjecaoVendasParametrizavel from "@/components/produto/detalhes/ProjecaoVenda/Parametrizacao/Index.vue";
import DashComparandoEvolucaoDePrecoDeCompras from '@/components/compra/detalhesProduto/DashComparandoEvolucaoDePrecoDeCompras/Index.vue';
import FormatarMoeda from "@/components/utils/FormatarMoeda.vue";
import AnalisePorLote from '@/components/produto/detalhes/AnalisePorLote/Index.vue';
import api from "@/api/api.js";
import LegendaTotalGeralEPorFilial from "@/components/produto/detalhes/CamposPersonalizados/LegendaTotalGeralEPorFilial.vue";
import { descricao_index_tipo_projecao_vendas } from "@/components/produto/detalhes/ProjecaoVenda/Parametrizacao/Simulacao/Helpers";
import DialogModeloPrevisaoAtual from "@/components/produto/detalhes/DialogModeloPrevisaoAtual.vue";

export default {
  name: "TabelaDetalhesProdutos",
  components: {
    DialogModeloPrevisaoAtual,
    LegendaTotalGeralEPorFilial,
    Legenda,
    Heranca,
    Similar,
    PrevisaoGatilho,
    InfluenciaDeProjecao,
    DetalhamentoEstoque,
    NivelEstoqueProgressCircular,
    Linha,
    RaioX,
    UltimasCompras,
    LoteMinimo,
    Ressuprimento,
    UltimasVendasProduto,
    CoberturaEstoqueManual,
    ComparativoPreco,
    DashComparandoEvolucaoDePrecoDeCompras,
    FormatarMoeda,
    ProjecaoVendasParametrizavel,
    AnalisePorLote
  },
  props: {
    produto: {
      type: Object,
      required: true
    },
    ocultarTituloEstoquesCoberturas: {
      type: Boolean,
      default: false
    },
    exibir_raio_x: {
      type: Boolean,
      default: false
    },
    atualizar_detalhes_count: Number,
    habilitar_edicao_parametros: {
      type: Boolean,
      default: false
    },
    click_bar: Object,
    ativar_filtro_revenda_direta: Boolean,
  },
  data: () => ({
    maximoDeColunas: 6,
    detalhesProduto: {},
    detalhesPersonalizados: ['ultimaCompra', 'mediaUltimasVendas', 'heranca'],
    flagAnalisePorLote: false,
    dialog_modelo_previsao_atual: false,
    dialog_tipo_projecao_venda: false
  }),
  computed: {
    linhas() {
      const linhas = [
        {
          colunas: [
            {texto: 'Prioridade', valor: 'peso_compras'},
            {texto: 'Preço de Compra', valor: 'preco_compra', formatarDinheiro: true},
            {texto: 'Ressuprimento', valor: 'tempo_medio_ressuprimento', formatar: true, append: 'dias'},
            {texto: 'Lote Mínimo', valor: 'lote_minimo', formatar: true},
            {texto: 'Similares', valor: 'qtde_similares'},
            {texto: 'Previsão Gatilho', valor: 'tempo_forecast', formatar: true, append: 'dias'},
          ]
        }
      ];

      if (this.exibir_raio_x) {
        linhas[0].colunas.push({texto: 'Raio X', valor: 'raio_x'});
      }

      if (!this.ocultarTituloEstoquesCoberturas) {
        linhas.push({
          divider: true,
          titulo: 'Estoques e coberturas',
        });
      }

      return [
        ...linhas,
        {
          colunas: [
            {texto: 'Nível Estoque', valor: 'nivel_estoque', rowspan: 2},
            {texto: 'Saldo Estoque', valor: 'estoque', formatar: true},
            {texto: 'Estoque Segurança', valor: 'estoque_seguranca', formatar: true},
            {texto: 'Ponto Pedido', valor: 'ponto_pedido', formatar: true},
            {texto: 'Estoque Máximo', valor: 'estoque_maximo', formatar: true},
            {texto: 'Estoque estético', valor: 'estoque_minimo', formatar: true},
          ]
        },
        {
          colunas: [
            {texto: 'Cobertura Estoque', valor: 'cobertura_estoque', formatar: true, append: 'dias'},
            {texto: 'Cobertura Eseg', valor: 'cobertura_diaria_esseg', formatar: true, append: 'dias'},
            {texto: 'Cobertura PP', valor: 'cobertura_diaria_pp', formatar: true, append: 'dias'},
            {texto: 'Cobertura Emax', valor: 'cobertura_diaria_emax', formatar: true, append: 'dias'},
            {texto: 'Giro Estoque', valor: 'giro_diario', formatar: true},
          ]
        },
        {
          colunas: [
            {texto: 'Status Produto', valor: 'status_produto'},
            {texto: 'Cobertura Manual', valor: 'cobertura_manual_produto'},
            {texto: 'Bloqueado', valor: 'estoque_bloqueado', formatar: true},
            {texto: 'Em Trânsito', valor: 'estoque_transito', formatar: true},
            {texto: 'Avaria', valor: 'estoque_avaria', formatar: true},
            {texto: 'Reservado', valor: 'estoque_reservado', formatar: true},
          ]
        },
        {
          divider: true,
          titulo: 'Herança',
          nome: 'heranca'
        },
        {
          colunas: [
            // {texto: 'Id Produto', valor: 'id_produto_heranca'},
            {texto: 'Nome do Produto', valor: 'nome_produto_heranca', colspan: 2},
            {texto: 'Data Cadastro', valor: 'cadastro_heranca'},
            {texto: 'Tipo', valor: 'tipo_heranca'},
            {texto: 'Últ. Compra', valor: 'valor_ultima_compra'},
            {texto: 'Últ. Ent. sem ST', valor: 'valor_ultima_entrada_sem_st'},
          ]
        },
        {
          divider: true,
          titulo: 'Última Compra',
          nome: 'ultima-compra'
        },
        {
          colunas: [
            {texto: 'Pedido', valor: 'ordem_compra'},
            {texto: 'Total', valor: 'total_compra'},
            {texto: 'Quantidade', valor: 'qtde_compra'},
            {texto: 'Solicitação', valor: 'data_solicitacao'},
            {texto: 'Previsão', valor: 'data_previsao'},
            {texto: 'Entrada', valor: 'data_entrega'}
          ]
        },
        {
          divider: true,
          titulo: 'Média de venda nos últimos meses',
          nome: 'media-venda-ultimos-meses'
        },
        {
          colunas: [
            {texto: '3 meses', valor: 'mediaTrimestre', formatar: true},
            {texto: '6 meses', valor: 'mediaSemestre', formatar: true},
            {texto: '12 meses', valor: 'mediaAno', formatar: true},
            {texto: 'Projeção vendas', valor: 'consumo_medio_mensal', formatar: true},
            {texto: 'Influência de Projeção', valor: 'percentual_projecao', formatar: true, colspan: 2, append: '%'}
          ]
        },
        {
          colunas: [
            {texto: '', valor: 'promo', formatar: true}
          ]
        }
      ]
    },
    ultimaCompraFormatada() {
      if (!this.detalhesProduto.ultimaCompra) {
        return {
          ordem_compra: '-',
          total_compra: '-',
          qtde_compra: 0,
          data_solicitacao: '-',
          data_previsao: '-',
          data_entrega: '-'
        }
      }

      const {
        ordem_compra,
        total_compra,
        qtde,
        data_solicitacao,
        data_previsao,
        data_entrega
      } = this.detalhesProduto.ultimaCompra;

      return {
        ordem_compra: ordem_compra || '-',
        total_compra: this.Helpers.formatarValorComCasas(total_compra, 2),
        qtde_compra: qtde,
        data_solicitacao,
        data_previsao: data_previsao || '',
        data_entrega: data_entrega || '-'
      };
    },
    mediaUltimasVendas() {
      if (!this.detalhesProduto.mediaUltimasVendas) {
        return {
          media_trimestre: 0,
          media_semestre: 0,
          media_ano: 0
        };
      }

      return this.detalhesProduto.mediaUltimasVendas;
    },
    herancaFormatada(){
      if (!this.detalhesProduto.heranca) {
        return {
          id_produto_heranca: '-',
          nome_produto_heranca: '-',
          cadastro_heranca: '-',
          tipo_heranca: '-',
        }
      }

      const {idproduto, descricao_produto, cadastro_heranca, tipo_heranca} = this.detalhesProduto.heranca;

      return {
        id_produto_heranca: idproduto || '-',
        nome_produto_heranca: descricao_produto ? `${idproduto} - ${descricao_produto}` : '-',
        cadastro_heranca: cadastro_heranca || '-',
        tipo_heranca: tipo_heranca,
      }
    },
    detalhesProdutoFormatado() {
      const detalhes = {};

      const chavesDeValoresPadrao = Object.keys(this.detalhesProduto).filter(
        key => !this.detalhesPersonalizados.includes(key)
      );

      chavesDeValoresPadrao.forEach(key => {
        detalhes[key] = this.detalhesProduto[key]
      })

      return {
        ...detalhes,
        ...this.ultimaCompraFormatada,
        ...this.mediaUltimasVendas,
        ...this.herancaFormatada
      };
    },
    embalagemMasterAtivo() {
      return this.$store.getters["EmbalagemTelaDeCompras/getEmbalagemMaster"];
    },
    formatarBadgeTipoProjecao () {
      if (this.detalhesProdutoFormatado.tipo_projecao_vendas === 'padrao_systock') {
        return { backgroundColor: '#F3F8FF', color: '#245AE5', marginRight: '-180px' };
      }

      return { backgroundColor: '#FFF3EC', color: '#FF8040', marginRight: '-180px' };
    },
    tipoProjecaoVendas() {
      const v = this.detalhesProduto ? this.detalhesProduto.tipo_projecao_vendas : null;
      return v != null && v !== "" ? String(v) : "padrao_systock";
    },
    truncarTipoProjecaoVendas() {
      return this.tipoProjecaoVendas.length > 16
    },
  },
  watch: {
    produto() {
      this.getDetalhesProdutos();
    },
    atualizar_detalhes_count() {
      this.getDetalhesProdutos();
    }
  },
  updated() {
    this.buscarFlagAnalisePorLote();
  },
  mounted() {
    this.getDetalhesProdutos();
  },
  methods: {
    buscarFlagAnalisePorLote() {
      api.get('compras/produtos/analise-por-lotes/flag').then(response => this.flagAnalisePorLote = response.data.flag);
    },
    getDetalhesProdutos() {
      const {id_produto, id_grupo, id_filial} = this.produto;

      const params = {
        produto: id_produto,
        grupo: id_grupo,
        filial: id_filial || 9999,
        visaoDrp: this.produto.visaoDrp || undefined,
        produto_eh_combinacao: this.produto.produto_eh_combinacao ? 'S' : 'N',
        produto_eh_categoria: this.produto.produto_eh_categoria ? 'S' : 'N',
        ativar_filtro_revenda_direta: this.ativar_filtro_revenda_direta ? 'S' : 'N',
        exibir_produtos_inativos: this.produto.exibir_produtos_inativos ? 'S' : 'N',
      }

      if (params.visaoDrp && this.produto.tipoDrp) {
        params.tipoDrp = this.produto.tipoDrp;
      }

      this.$store.dispatch(
        "loading/addRequisicao",
        ProdutoAPI.getDetalhesProduto(params)
          .then(response => {
            const {token, detalhes} = response.data;
            localStorage.token = token;
            this.detalhesProduto = detalhes;
          })
          .catch(() => (this.Helpers.logout()))
      );
    },
    converterEmbalagemValor(valor, dinheiro = false) {
      if (!this.detalhesProduto.tipo_fator_conversao || !this.embalagemMasterAtivo) {
        return valor;
      }

      return dinheiro
        ? converterEmbalagemValorDinheiro(this.detalhesProduto, valor)
        : converterEmbalagemValor(this.detalhesProduto, valor);
    },
    formatarTipoProjecaoVendas(tipo_projecao_vendas) {
      return descricao_index_tipo_projecao_vendas[tipo_projecao_vendas];
    }
  }
}
</script>

<style scoped>
</style>
